import { useState } from "react";
import { Play } from "lucide-react";

export const ytId = (u) => (u || "").match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/)?.[1] || null;

export default function SalesVideo({ url }) {
  const id = ytId(url);
  const [play, setPlay] = useState(false);
  if (id && play) {
    return (
      <div className="aspect-video w-full rounded-2xl overflow-hidden border bg-black shadow-xl" data-testid="sales-video-player">
        <iframe className="w-full h-full" src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`} title="Veja como funciona o Cem Zebra AI"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
      </div>
    );
  }
  return (
    <button type="button" disabled={!id} onClick={() => setPlay(true)} data-testid={id ? "sales-video-play" : "sales-video-placeholder"}
      aria-label={id ? "Reproduzir vídeo" : "Vídeo em breve"}
      className="group relative aspect-video w-full rounded-2xl overflow-hidden border bg-[#0f1115] shadow-xl disabled:cursor-default">
      {id ? <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-[1.03]" />
        : <div className="absolute inset-0 zebra-stripes opacity-25" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <span className="absolute inset-0 grid place-items-center">
        <span className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-primary text-primary-foreground grid place-items-center shadow-2xl transition-transform duration-200 group-hover:scale-110 group-enabled:animate-none">
          <Play className="h-7 w-7 sm:h-8 sm:w-8 ml-1" fill="currentColor" />
        </span>
      </span>
      <span className="absolute left-4 bottom-4 right-4 text-left text-white">
        <span className="block text-sm sm:text-base font-semibold">{id ? "Assista à demonstração" : "Vídeo em breve"}</span>
        {!id && <span className="block text-xs text-white/70 mt-0.5" data-testid="sales-video-soon">O vídeo explicativo será publicado aqui em breve.</span>}
      </span>
    </button>
  );
}
